var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2658",
    "data-name": "Group 2658",
    transform: "translate(-81 -375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(31 158)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(50 217)",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(56 223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 11,
    height: 11,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M7.545,9.286,8.938,8.009a.426.426,0,0,1,.348-.116l.232.116,3.25,1.509c.232.116.232.232.232.464a2.943,2.943,0,0,1-.929,2.089A3.325,3.325,0,0,1,9.634,13a7.072,7.072,0,0,1-3.25-.812,15.216,15.216,0,0,1-3.25-2.321A19.77,19.77,0,0,1,1.393,7.313,16.044,16.044,0,0,1,.232,4.759,7.143,7.143,0,0,1,0,2.554,3.05,3.05,0,0,1,.813.813,3.53,3.53,0,0,1,3.018,0a.6.6,0,0,1,.464.232l1.741,3.25a.405.405,0,0,0,.116.232.426.426,0,0,1-.116.348L3.714,5.455a.518.518,0,0,0,0,.58A11.084,11.084,0,0,0,5.107,7.893,11.72,11.72,0,0,0,6.964,9.4C7.2,9.518,7.429,9.518,7.545,9.286Z",
    transform: "translate(0 0)",
    fill: "#0094d9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.3bc13f7ee96339dc86e479a35c1fc75e.svg";
export { ForwardRef as ReactComponent };